<template lang="pug">
  b-row(no-gutters)
    b-col.col-2.col-md-1(v-if="to")
      b-button.mt-2.mt-md-3(:to="to" variant="outline-light" v-if="to" size="sm" pill)
        b-icon-arrow-left(variant="dark")
    b-col
      b-img( :src="alang('section1.logo')" fluid)
</template>

<script>
import util from '@/common/lang/util'
export default {
  name: 'Section1Widget',
  mixins: [util],
  props: {
    to: null,
  }
}
</script>
